export default __webpack_public_path__ + "static/1_ClearBraces-29ac125a17c95436194d1b024379da10.jpg";